import { Routes } from '@angular/router';
import { authGuard } from '../guard/auth.guard';

export const content: Routes = [
  {
    path: "sample-page",
    loadChildren: () => import("../../components/sample-page/sample-page.module").then((m) => m.SamplePageModule),
    canActivate:[authGuard]
  },
  {
    path: "sample-page3",
    loadChildren: () => import("../../components/sample-page3/sample-page3.module").then((m) => m.SamplePage3Module),
    canActivate:[authGuard]
  },
  {
    path: "services",
    loadChildren: () => import("../../components/services/services.module").then((m) => m.ServicesModule),
    canActivate:[authGuard]
  },
  {
    path: "users",
    loadChildren: () => import("../../components/users/users.module").then((m) => m.UsersModule),
    canActivate:[authGuard]
  },
  {
    path: "dashboard",
    loadChildren: () => import("../../components/company-dashboard/companydashboard.module").then((m) => m.CompanyDashboardModule),
    canActivate:[authGuard]
  },
  {
    path: "admin",
    loadChildren: () => import("../../components/admin-portal/admin-portal-page.module").then((m) => m.AdminPortalPageModule),
    canActivate:[authGuard]
  },
  {
    path: "affidavit",
    loadChildren: () => import("../../pages/drafting-document/drafting-document.module").then((m) => m.DraftingDocumentModule),
    canActivate:[authGuard]
  },
  {
    path: "agreement",
    loadChildren: () => import("../../components/agreement/agreement.module").then((m) => m.AgreementModule),
    canActivate:[authGuard]
  },
  {
    path: "calculator",
    loadChildren: () => import("../../components/calculator/calculator.module").then((m) => m.CalculatorModule),
    canActivate:[authGuard]
  },
  {
    path: "purchase",
    loadChildren: () => import("../../components/after-purchase/after-purchase.module").then((m) => m.AfterPurchaseModule),
    canActivate:[authGuard]
  },
  {
    path: "banking",
    loadChildren: () => import("../../components/banking/banking-main.module").then((m) => m.BankingModule),
    canActivate:[authGuard]
  },
   {
    path: "access-management",
    loadChildren: () => import("../../components/acccess-management/access-management.module").then((m) => m.AccessManagementModule),
    canActivate:[authGuard]
  }
];